import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Cluster } from '../../models/cluster';
import { ClusterService } from '../../services/cluster.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Zone } from '../../models/zone';
import { ZoneService } from '../../services/zone.service';
import { State } from '../../models/state';
import { StateService } from '../../services/state.service';
import { Region } from '../../models/region';
import { RegionService } from '../../services/region.service';
import { Division } from '../../models/division';
import { DivisionService } from '../../services/division.service';

@Component({
  selector: 'app-cluster',
  templateUrl: './cluster.component.html',
  styleUrls: ['./cluster.component.css']
})
export class ClusterComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerCluster: PageHeader;
  entity: Cluster = new Cluster();
  selectedCluster: Cluster = new Cluster();
  editingEntity: Cluster = new Cluster();
  clusters: any;
  clusterColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  company: Array<Company> = [];
  selectedCompany: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  zone: Array<Zone> = [];
  selectedZone: any;
  state: Array<State> = [];
  selectedState: any;
  region: Array<Region> = [];
  selectedRegion: any;
  division: Array<Division> = [];
  selectedDivision: any;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  opened: boolean = false;
  details: any;
  constructor(
    private _clusterService: ClusterService,
    private _divisionService: DivisionService,
    private _regionService: RegionService,
    private _companyService: CompanyService,
    private _zoneService: ZoneService,
    private _stateService: StateService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private _employeeService: EmployeeService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerCluster = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.clusters = [];
    this.getAllCluster();
  }

  ngAfterViewInit(): void {

    this.clusterColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "ClusterName", title: 'Cluster', filter: true, sortable: true, width: 150 },
      { field: "ClusterCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "EmployeeName", title: 'Cluster Head', filter: true, sortable: true, width: 150 },
      { field: "ClusterMail", title: 'Email Id', filter: true, sortable: true, width: 100 },
      { field: "ClusterPhone", title: 'Phone', filter: true, sortable: true, width: 100 },
      { field: "DivisionName", title: 'Area', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._clusterService.getAllClusters('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Cluster>) => {
      this.clusters = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }

  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  // getAllZone(filter: string) {
  //   this._zoneService.getAllZones(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Zone>) => {
  //     this.zone = data;
  //   })
  // }
  getAllState(filter: string) {
    this._stateService.getAllStates(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<State>) => {
      this.state = data;
    })
  }
  getAllRegion(filter: string) {
    this._regionService.getAllRegions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Region>) => {
      this.region = data;
    })
  }
  getAllDivision(filter: string) {
    this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
      this.division = data;
    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._clusterService.getAllClusters(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((clusters: Array<Cluster>) => {
        this.clusters = {
          data: clusters,
          total: clusters[0] ? clusters[0].TotalCount : 0
        }
      });
    }
  }
  getAllCluster() {
    this._clusterService.getAllClusters('', Number(this.defaultPageSize), 1, 0, 0).subscribe((clusters: Array<Cluster>) => {
      this.clusters = {
        data: clusters,
        total: clusters[0] ? clusters[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._clusterService.deleteCluster(this.selectedCluster.Cluster_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearCluster();
            this.getAllCluster();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerCluster = new PageHeader();
    headerCluster.PageCaption = "Cluster";
    headerCluster.IconClass = "bi bi-shield-shaded";
    return headerCluster;
  }

  deleteCluster(event: any) {
    if (event.seletedRows[0]) {
      this.selectedCluster.Cluster_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Cluster",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addCluster(event: any) {
    this.listView = false;
    this.clearCluster();
    this.getAllCompany('');
    this.getAllEmployees('');
    this.getAllZone('');
    this.getAllState('');
    this.getAllRegion('');
    this.getAllDivision('');
    this.formCaption = "Add Cluster";
  }

  editCluster(event: any): void {
    if (event.seletedRows[0]) {
      this._clusterService.viewCluster(event.seletedRows[0]).subscribe((clusters: Array<Cluster>) => {
        let editEnity = clusters[0] ? clusters[0] : new Cluster();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
          this.selectedZone = { Zone_Id: editEnity.Zone_Id, Zone_Name: editEnity.ZoneName };
          this.selectedState = { State_Id: editEnity.State_Id, State_Name: editEnity.StateName };
          this.selectedRegion = { Region_Id: editEnity.Region_Id, Region_Name: editEnity.RegionName };
          this.selectedDivision = { Division_Id: editEnity.Division_Id, Division_Name: editEnity.DivisionName };

          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Cluster";
          this.getAllCompany('');
          this.getAllEmployees('');
          this.getAllZone(this.entity.State_Id);
          this.getAllStatesbyRegion(this.entity.Region_Id);
          this.getAllregionbyDivision(this.entity.Division_Id);
          this.getAllDivision('');
          this.entity.EntityMetaData = [
            { FieldName: 'ClusterName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Cluster Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Cluster Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            //{ FieldName: 'Zone_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone is required' },     
            //{ FieldName: 'State_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State is required' },    
            //{ FieldName: 'Region_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Region is required' },   
            //{ FieldName: 'Division_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division is required' },         
          ];
        }
      });
    }
  }

  save(event: any): void {
    if (parseInt(this.entity.Code) == 0) {
      this.notification.showWarning('zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._clusterService.checkDuplication(this.entity.Cluster_Id, this.entity.Code).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Cluster Code already exists');
          this.saveDisabled = false;
        }
        else {
              if (this.entity.Phone != "" && this.entity.Phone.length != 10) {
              this.notification.showWarning("Invalid Phone No.");
              this.saveDisabled = false;
              return
            
          }
          // const re = /^(0*[1-9]+0*)+$/;
          // const real=/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
          // this.codeCheck = re.test(String(this.entity.Code).toString());
          // this.codealCheck = real.test(String(this.entity.Code).toString());
          // if (this.codealCheck == false&&this.codeCheck==false ) {

          //   this.notification.showWarning("Invalid code ");
          //   this.saveDisabled = false;

          // }
          else {
          if (this.entity.EmailId != "") {
            // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; commented on 04-06-2024 by jessil for #I238
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
            if (this.emailcheck === false) {
              this.notification.showWarning("Email not valid");
              this.saveDisabled = false;
              return;
            }
          }
          this._clusterService.checkEmail(this.entity.EmailId, this.entity.Cluster_Id).subscribe((response) => {
           if (response.Success == false) {
                  this.notification.showWarning("Email already exists");
                  this.saveDisabled = false;
                  return;
                }
                else {
                  this._clusterService.saveCluster(this.entity).subscribe(() => {
                    if (this.entity.Cluster_Id == '00000000-0000-0000-0000-000000000000') {
                      this.notification.showSuccess('Saved Successfully');
                    }
                    else {
                      this.notification.showSuccess('Updated Successfully');
                    }
                    this.listView = true;
                    this.clearCluster();
                    this.getAllCluster();
                  });
                }
              });
            }
          // }
          }
      });
    
    }
    else {
      this.saveDisabled = false;
    }

  }
  goToBackTab(): void {

    this.listView = true;

  }
  Divisionchanged(diviion: any) {
    this.state = [];
    this.entity.Zone_Id = '';
    this.entity.State_Id = '';
    this.entity.Region_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    this.selectedState = { State_Id: '', Zone_Name: '' };
    this.selectedRegion = { Region_Id: '', Region_Name: '' };
    if (diviion) {

      this.getAllregionbyDivision(diviion.Division_Id);

    }
  }

  getAllregionbyDivision(filter: string) {
    this._regionService.getAllregionbyDivision(filter).subscribe((data: Array<Region>) => {
      this.region = data;
    })

  }



  Regionchanged(region: any) {
    this.state = [];
    this.entity.Zone_Id = '';
    this.entity.State_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    this.selectedState = { State_Id: '', Zone_Name: '' };

    if (region) {
      // this.getAllState(this.entity.State_Id);
      this.getAllStatesbyRegion(region.Region_Id);
      //this.getAllZone('');
    }
  }

  getAllStatesbyRegion(filter: string) {
    this._stateService.getAllStatesbyRegion(filter).subscribe((data: Array<State>) => {
      this.state = data;
    })
    //this.selectedZone = { Zone_Id: this.state[0].Zone_Id, Zone_Name: this.state[0].ZoneName };
    //this.selectedState = { State_Id: this.state[0].State_Id, StateName: this.state[0].StateName };
    // this.getAllZone('');
    // this.getAllState('');
  }
  Statechanged(state: any) {
    this.zone = [];
    this.entity.Zone_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    if (state) {
      // this.getAllState(this.entity.State_Id);
      this.getAllZone(this.entity.State_Id);
    }
  }
  getAllZone(filter: string) {

    this._zoneService.getAllStatesbyzone(filter).subscribe((data: Array<Zone>) => {
      this.zone = data;
    })
    // this.selectedZone = { Zone_Id: this.zone[0].Zone_Id, Zone_Name: this.zone[0].Zone_Id };

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllCluster();
  }

  refreshClusters(event: any): void {
    this.clusters = [];
    this.getAllCluster();
  }

  clearCluster(): void {
    this.selectedCompany = {};
    this.selectedEmployee = {};
    this.selectedZone = {};
    this.selectedState = {};
    this.selectedRegion = {};
    this.selectedDivision = {};
    this.entity = new Cluster();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Cluster_Id = dataItem.Cluster_Id;
    this.details = [];
    this._clusterService.viewCluster(this.entity.Cluster_Id).subscribe((clusters: Array<Cluster>) => {
      this.opened = true;
      this.details = clusters[0];
    })
  }

}
